import { inject } from '@angular/core'
import { CanActivateFn, CanActivateChildFn } from '@angular/router'

import { from } from 'rxjs'

import { AuthService } from './auth.service'
import { tap } from 'rxjs/operators'

const returnURL = 'https://www.sportsengine.com'

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)

  return from(authService.isAdmin()).pipe(
    tap((isAdmin) => {
      console.log('isAdmin', isAdmin)
      if (!isAdmin) {
        window.location.href = returnURL
      }
    })
  )
}

// canActivateChild just calls canActivate
export const adminChildGuard: CanActivateChildFn = (route, state) =>
  adminGuard(route, state)
